import { Grid, NumberInput, Select } from "@mantine/core"
import type React from "react"
import { useEffect } from "react"
import { useForm } from "react-hook-form"

interface FilterOption {
  label: string
  value: string
}

interface FilterFormData {
  tags: string
  program: string
  category: string
  priceMin: string
  priceMax: string
  tag: string
}

interface MenuOffersFilterProps {
  categoriesOptions: FilterOption[]
  programsOptions: FilterOption[]
  tagsOptions: FilterOption[]
  onFilterChange: (filters: {
    category: string
    tag: string
    program: string
    priceMin: string
    priceMax: string
  }) => void
}

const MenuOffersFilter: React.FC<MenuOffersFilterProps> = ({
  categoriesOptions,
  programsOptions,
  tagsOptions,
  onFilterChange,
}) => {
  const { watch, setValue } = useForm<FilterFormData>({
    defaultValues: {
      tags: "",
      program: "",
      category: "",
      priceMin: "",
      priceMax: "",
    },
  })

  const tag = watch("tag")
  const program = watch("program")
  const category = watch("category")
  const priceMin = watch("priceMin")
  const priceMax = watch("priceMax")

  useEffect(() => {
    setValue("tag", "")
    setValue("program", "")
  }, [category, setValue])

  useEffect(() => {
    onFilterChange({ category, tag, program, priceMin, priceMax })
    // eslint-disable-next-line
  }, [category, tag, program, priceMin, priceMax])

  return (
    <form>
      <Grid>
        <Grid.Col span={{ base: 4 }}>
          <Select
            data={[
              { value: "", label: "Categoria" },
              ...categoriesOptions.map((o) => ({ value: o.value, label: o.label })),
            ]}
            placeholder="Categoria"
            clearable
            value={category}
            onChange={(val) => setValue("category", val || "")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 4 }}>
          <Select
            data={[
              { value: "", label: "Tag" },
              ...tagsOptions.map((o) => ({ value: o.value, label: o.label })),
            ]}
            placeholder="Tag"
            clearable
            value={tag}
            onChange={(val) => setValue("tag", val || "")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 4 }}>
          <Select
            data={[
              { value: "", label: "Programa" },
              ...programsOptions.map((o) => ({ value: o.value, label: o.label })),
            ]}
            placeholder="Programa"
            clearable
            value={program}
            onChange={(val) => setValue("program", val || "")}
          />
        </Grid.Col>

        <Grid.Col span={{ base: 6 }}>
          <NumberInput
            placeholder="Valor min"
            onChange={(val) => setValue("priceMin", val ? String(val) : "")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 6 }}>
          <NumberInput
            placeholder="Valor max"
            onChange={(val) => setValue("priceMax", val ? String(val) : "")}
          />
        </Grid.Col>
      </Grid>
    </form>
  )
}

export default MenuOffersFilter